export const PUBLISHED_EXTENSION_ID = 'laoahcalgdmfecdbiodloilhcafeoafl';
export const LOCAL_EXTENSION_ID = 'gdghiffindlfdbncdfeblcfjjdibkmmd';

export const EXTENSION_IDS = [
  PUBLISHED_EXTENSION_ID,
  LOCAL_EXTENSION_ID
];

// Fallback for single ID if needed elsewhere
export const EXTENSION_ID = PUBLISHED_EXTENSION_ID;
